import { render } from "./FileShare.vue?vue&type=template&id=77fe3d08"
import script from "./FileShare.vue?vue&type=script&lang=js"
export * from "./FileShare.vue?vue&type=script&lang=js"

import "./FileShare.vue?vue&type=style&index=0&id=77fe3d08&lang=css"

import exportComponent from "/var/jenkins_home/workspace/mobysuite-docs-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__